import { NodeTypeCodes } from '@kcftech/prometheus-client';
import {
    EnvelopedDetails,
    EnvelopedLabel,
    EnvelopedRow,
    EnvelopedValue,
} from 'components/node_settings/V4EditSettingsModal/AdvancedSettingsTab/styled';
import { ToggleSetting } from 'components/node_settings/V4Settings/ToggleSetting';
import { DisabledHint } from 'components/node_settings/V4EditSettingsModal/styled';
import { NumericOptionDropdown } from 'components/dropdown/NumericOptionDropdown';
import { useSamplingFrequencyOptions } from 'custom_hooks/data_hooks/nodes/useSamplingFrequencyOptions';
import {
    DEFAULT_ENVELOPED,
    V4SensorSettings,
} from 'custom_hooks/data_hooks/v4_sensor_settings/shared';
import { Controller, useFormContext, useWatch } from 'react-hook-form';

export function EnvelopedDataSetting() {
    const { control, setValue } = useFormContext<V4SensorSettings>();
    const envelopedData = useWatch({ control, name: 'envelopedData' });
    const vibrationY = useWatch({ control, name: 'vibrationY' });

    const { validOptions: samplingFrequencyOptions } = useSamplingFrequencyOptions(
        NodeTypeCodes.KcfVibrationV4,
        undefined,
    );

    const hint = vibrationY
        ? 'Enable enveloped data for Y axis to sample data'
        : 'Enable vibration data for Y axis to sample data';

    return (
        <>
            <ToggleSetting
                name="Enveloped Data (Y Axis)"
                ariaLabel="Enveloped Data (Y Axis)"
                helperText="Several peaks will be treated as a single peak for enveloping Y-Axis data collection."
                checked={envelopedData.enabled}
                disabled={!vibrationY}
                onChange={(checked) =>
                    setValue(
                        'envelopedData',
                        checked ? DEFAULT_ENVELOPED : { enabled: false },
                        { shouldDirty: true, shouldValidate: true },
                    )
                }
            />
            <EnvelopedDetails>
                <EnvelopedRow>
                    <EnvelopedLabel>Sampling Frequency</EnvelopedLabel>
                    {envelopedData.enabled ? (
                        <EnvelopedValue>
                            <Controller
                                control={control}
                                name="envelopedData.samplingFrequencyHz"
                                render={({ field }) => (
                                    <NumericOptionDropdown
                                        value={field.value}
                                        options={samplingFrequencyOptions}
                                        onChange={field.onChange}
                                    />
                                )}
                            />
                        </EnvelopedValue>
                    ) : (
                        <DisabledHint>{hint}</DisabledHint>
                    )}
                </EnvelopedRow>
                <EnvelopedRow>
                    <EnvelopedLabel>Number of Samples</EnvelopedLabel>
                    {envelopedData.enabled ? (
                        // Fixed at 1000 to preserve battery; not user-configurable.
                        <EnvelopedValue>
                            {envelopedData.numberOfSamples} Samples
                        </EnvelopedValue>
                    ) : (
                        <DisabledHint>{hint}</DisabledHint>
                    )}
                </EnvelopedRow>
            </EnvelopedDetails>
        </>
    );
}
